import React, { useEffect } from 'react'
import AnimatedIcon from '/react4xp/components/AnimatedIcon'
import Section from '/react4xp/components/Section'
import SolutionsIcon from '/react4xp/components/SolutionsIcon'

interface AnimatedIconProps {
   name: string,
   path: string,
   href: string,
}

interface Props {
   title?: string,
   intro?: string,
   solutions?: AnimatedIconProps[],
   darker?: boolean,
   componentPath: string
}

export default function Solutions(props: Props) {
   const { title, intro, solutions, darker, componentPath } = props
   const animatedIconPaths = solutions.map((solution) => {
      return {
         name: solution.name,
         path: solution.path,
         href: solution.href,
      }
   })

   useEffect(() => {
      document.dispatchEvent(new CustomEvent('ourSolutionsLoaded', { detail: { componentId: componentPath } }))
  }, [])
   
   return (
      <Section id={componentPath} bgColor={darker ? 'bg-primary': 'bg-blue-primary-500'} textColor="text-light">
         <div className="grid-container solutions">
            <div className="grid-row solutions__wrapper">
               <div className="c-12 start-md-4 c-md-6 solutions__header">
                  {title && <h2 className="solutions__title">{title}</h2>}
                  {intro && <p className="solutions__intro">{intro}</p>}
               </div>
               <div className="c-12 solutions__icons">
                  {animatedIconPaths.map((icon, i) => (
                     <SolutionsIcon key={i} href={icon.href} animationPath={icon.path} label={icon.name} />
                  ))}
               </div>
            </div>
         </div>
      </Section>
   )
}
